if (!customElements.get('delivery-time')) {
    class DeliveryTime extends HTMLElement {

        constructor() {
            super();
            this.submit = this.querySelector('button');

            this.fromHour = this.querySelector('select[name="from-hour"]');
            this.fromMinute = this.querySelector('select[name="from-minute"]');
            this.toHour = this.querySelector('select[name="to-hour"]');
            this.toMinute = this.querySelector('select[name="to-minute"]');
        }

        connectedCallback() {
            this.submit?.addEventListener('click', this.handleSubmit.bind(this));
        }

        disconnectedCallback() {
            this.submit?.removeEventListener('click', this.handleSubmit.bind(this));
        }

        async handleSubmit() {

            this.submit.disabled = true;
            this.submit.classList.add('is-loading');
            this.submit.setAttribute('aria-disabled', 'true');

            const fromTime = `${this.fromHour.value}${this.fromMinute.value}00`;
            const toTime = `${this.toHour.value}${this.toMinute.value}00`;

            const formData = new FormData();
            formData.append('attributes[delivery_time_from]', fromTime);
            formData.append('attributes[delivery_time_to]', toTime);

            const headers = window.getCartHeaders();
            delete headers['Content-Type']; // Remove Content-Type for FormData
            
            await fetch(`${window.theme.routes.cartUpdate}.js`, {
                method: 'POST',
                headers: headers,
                body: formData,
            });

            // const checkoutId = localStorage.getItem('checkoutId');

            // if (checkoutId) {
            //     await window.checkout.update(checkoutId);
            // }

            this.submit.disabled = false;
            this.submit.classList.remove('is-loading');
            this.submit.setAttribute('aria-disabled', 'false');
        }
    }

    customElements.define('delivery-time', DeliveryTime);
}